export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8415.d0e5048d.jpg";